jQuery.fn.extend({
  IconSelectBox: function (img) {
    var defaultSelect = '#' + this.prop('id');
    var optionArray = [];
    // convert id to class if id given as selector
    var prefix_class = defaultSelect.replace('#', '.');

    var createElements = function () {
      var btn_select = extractText(defaultSelect);

      var button = document.createElement('button');
      button.classList = btn_select + '-select-box';

      var div = document.createElement('div');
      div.classList = btn_select + '-b';

      var ul = document.createElement('ul');
      ul.classList = btn_select + '-a';

      $(div).append(ul);

      $(button).insertAfter(defaultSelect);

      $(div).insertAfter(button);
    };

    var getStorage = function () {
      var lastSelected = localStorage.getItem(
        extractText(prefix_class) + '-curr'
      );

      if (lastSelected) {
        //find an item with value of lastSelected

        $(prefix_class + '-select-box').html(
          lastSelected +
            ' <div class="svg-country"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M8.49677 8.95285L4.25413 4.71016C3.86361 4.31963 3.23045 4.31963 2.83992 4.71015C2.4494 5.10067 2.44939 5.73383 2.83992 6.12436L8.49677 11.7812L14.1537 6.12435C14.5442 5.73383 14.5442 5.10067 14.1537 4.71015C13.7632 4.31963 13.13 4.31963 12.7395 4.71015L8.49677 8.95285Z" fill="black"/></svg></div>'
        );
        var val = $(prefix_class + '-select-box')
          .find('[data-value]')
          .data('value');
        var val2 = $(prefix_class + '-select-box')
          .find('[data-country]')
          .data('country');

        $(defaultSelect).val(val).change();
        $(defaultSelect).val(val2).change();
      } else {
        $(prefix_class + '-select-box').html(
          optionArray[0] +
            '<div class="svg-country 1"><svg height="14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="caret-down" class="svg-inline--fa fa-caret-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg></div>'
        );
        var val = $(optionArray[0]).find('[data-value]').data('value');
        var val2 = $(optionArray[0]).find('[data-country]').data('country');

        $(defaultSelect).val(val).change();
        $(defaultSelect).val(val2).change();
      }
    };

    var extractText = function () {
      return defaultSelect.indexOf('#') > -1
        ? defaultSelect.replace('#', '')
        : defaultSelect.replace('.', '');
    };

    var addCss = function () {
      const head = document.querySelector('head');
      const css =
        prefix_class +
        '-a {' +
        'padding-left: 0px;' +
        'background: #faf9f9;' +
        'margin-bottom: 0px;' +
        '}' +
        prefix_class +
        '-a img, ' +
        prefix_class +
        '-select-box img{' +
        'width: 25px;' +
        '}' +
        prefix_class +
        '-a li{' +
        'list-style: none;' +
        'padding: 10px;' +
        'text-align: left !important;' +
        '}' +
        prefix_class +
        '-a li:not(:last-child){' +
        'border-bottom: 1px solid #dcd6d6;' +
        '}' +
        prefix_class +
        '-a li:hover{' +
        'background-color: #F4F3F3;' +
        '}' +
        prefix_class +
        '-a li img {' +
        'margin: 5px;' +
        '}' +
        prefix_class +
        '-a li span, ' +
        prefix_class +
        '-select-box li span {' +
        'margin-left: 30px;' +
        '}' +
        prefix_class +
        '-b {' +
        'position: absolute;' +
        'display: none;' +
        'width: 100%;' +
        'box-shadow: 0 6px 12px rgba(0,0,0,.175);' +
        'border: 1px solid rgba(0,0,0,.15);' +
        'z-index: 9999;' +
        '}' +
        prefix_class +
        '-select-box {' +
        'display: flex;' +
        'align-items: center;' +
        'position: relative;' +
        'width: 100%;' +
        'min-height: 64px;' +
        'background-color: #fff;' +
        'border: 1px solid #C5CAD1;' +
        'border-radius: 8px;' +
        'padding: 19.5px 20px;' +
        '}' +
        prefix_class +
        '-select-box i {' +
        'font-size: 2rem;' +
        'top: 10%;' +
        'position: relative;' +
        '}' +
        prefix_class +
        '-select-box li i {' +
        'font-size: 1.5rem;' +
        '}' +
        prefix_class +
        '-select-box li {' +
        'display: flex;' +
        'align-items: center;' +
        'list-style: none;' +
        'float: left;' +
        'padding-bottom: 0px;' +
        'width: 95%;' +
        'text-align: left;' +
        '}' +
        prefix_class +
        '-select-box li {' +
        'font-size: 16px;' +
        'line-height: 20px;' +
        'font-weight: bold;' +
        'color: #0F1821;' +
        'cursor: pointer;' +
        '}' +
        prefix_class +
        '-select-box:hover li {' +
        'margin-left: 0px;' +
        '}' +
        prefix_class +
        '-select-box:hover {' +
        'background-color: #fff;' +
        'border: 1px solid #C5CAD1;' +
        'border-radius: 8px;' +
        '}' +
        prefix_class +
        '-select-box:focus {' +
        'outline:none;' +
        '}';

      $(head).append('<style> ' + css + ' </style>');
    };

    $(defaultSelect).hide();

    $(defaultSelect + ' option').each(function () {
      var text = this.innerText;
      var value = this.value;
      var valueCountry = $(this).data('country');
      var icon = $(this).data('icon');

      var iconEl = img
        ? '<img src="' +
          icon +
          '" alt="icon" data-country="' +
          valueCountry +
          '" data-value="' +
          value +
          '"/>'
        : '<i class="' + icon + '" data-value="' + value + '"></i>';

      var item = '<li>' + iconEl + ' <span>' + text + '</span></li>';
      optionArray.push(item);
    });

    createElements();
    addCss();

    $(prefix_class + '-a').html(optionArray);

    getStorage();

    //change button stuff on click
    $(prefix_class + '-a li').click(function () {
      var icon = img
        ? $(this).find('img').attr('src')
        : $(this).find('i').attr('class');
      var value = img
        ? $(this).find('img').data('value')
        : $(this).find('i').data('value');
      var valueCountry = img
        ? $(this).find('img').data('country')
        : $(this).find('i').data('country');
      var text = this.innerText;

      var iconEl = img
        ? '<img src="' +
          icon +
          '" alt="icon" data-country="' +
          valueCountry +
          '" data-value="' +
          value +
          '"/>'
        : '<i class="' + icon + '" data-value="' + value + '"></i>';

      var item = '<li>' + iconEl + ' <span> ' + text + ' </span>' + '</li>';

      $(prefix_class + '-select-box').html(
        item +
          '<div class="svg-country"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M8.49677 8.95285L4.25413 4.71016C3.86361 4.31963 3.23045 4.31963 2.83992 4.71015C2.4494 5.10067 2.44939 5.73383 2.83992 6.12436L8.49677 11.7812L14.1537 6.12435C14.5442 5.73383 14.5442 5.10067 14.1537 4.71015C13.7632 4.31963 13.13 4.31963 12.7395 4.71015L8.49677 8.95285Z" fill="black"/></svg></div>'
      );

      $(defaultSelect).val(value).change();
      $(prefix_class + '-b').toggle();

      localStorage.setItem(extractText(prefix_class) + '-curr', item);
    });

    $(prefix_class + '-select-box').click(function () {
      $(this).find('.svg-country').toggleClass('open');
      var cls = $(this).find('[data-arrow]').attr('class');
      if (cls === 'fa fa-angle-up') {
        $(this).find('[data-arrow]').attr('class', 'fa fa-caret-down');
      } else {
        $(this).find('[data-arrow]').attr('class', 'fa fa-angle-up');
      }

      $(prefix_class + '-b').toggle();
    });
  }
});
